var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"button",class:[
    ("button--" + _vm.kind),
    ("button--" + _vm.size),
    { 'button--loading': _vm.isLoading } ],attrs:{"data-test":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.isLoading)?_c('div',{staticClass:"button__circle",attrs:{"data-test":"loading"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }